import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Navigation(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Navigation", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.5768 2.73331c-4.2211.28989-7.6495 3.69218-7.9703 7.91089-.1571 2.0646.4167 3.9885 1.4875 5.5439.2177.3163 1.1055 1.315 1.3169 1.5064l4.6279 4.6279c.633.633 1.6593.633 2.2922 0l4.6328-4.6329c.2076-.1883 1.0921-1.1831 1.3112-1.5014.9538-1.3853 1.5132-3.0629 1.5132-4.872 0-4.95273-4.1848-8.92803-9.2114-8.58279Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.184 15.7528c2.6236 0 4.7504-2.1269 4.7504-4.7505 0-2.62362-2.1268-4.75047-4.7504-4.75047s-4.7505 2.12685-4.7505 4.75047c0 2.6236 2.1269 4.7505 4.7505 4.7505Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M42.1399 22.7272c-.8043-.8044-2.1084-.8044-2.9127 0l-9.9324 9.9323-18.2371-18.237c-.8972-.8972-2.35191-.8972-3.2492 0-.8972.8973-.8972 2.352 0 3.2492l5.738 5.738-7.94319 7.9433c-.80441.8044-.80441 2.1085 0 2.9128.8043.8043 2.10846.8043 2.91276 0l7.94333-7.9433 18.0043 18.0044c.8971.8972 2.3519.8972 3.2491 0 .8972-.8972.8972-2.3519 0-3.2492l-5.5052-5.5053 9.9323-9.9324c.8043-.8044.8043-2.1085 0-2.9128Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m29.2951 32.6599 2.9128 2.9128 3.1074-3.1074-3.0101-2.8156-3.0101 3.0102Zm-18.8254-6.1728 2.9135 2.9122 3.0765-3.0764-2.9129-2.9127-3.0771 3.0769Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
Navigation.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Navigation"
};
validateTidalLicense();
export {
  Navigation
};
//# sourceMappingURL=Navigation.js.map
